import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { Router } from '@angular/router';

/**
 * OID 笔资源包管理 API（后端模块 OidPenPackagesManage，前缀 oid-pen）。
 * 大纲与资源包走本服务；标签库仍走 /v3/api/tags/article/*，与后端 API 文档一致。
 */
@Injectable({
  providedIn: 'root'
})
export class OidPenPackagesService extends BaseService {
  private readonly base = '/oid-pen';

  constructor(protected override http: HttpClient, protected override router: Router) {
    super(http, router);
  }

  // --- Syllabus（大纲 / 分类）---
  getSyllabus() {
    return this.get(`${this.base}/syllabus`);
  }

  createSyllabus(data: any) {
    return this.post(`${this.base}/syllabus`, data);
  }

  updateSyllabus(id: number | string, data: any) {
    return this.patch(`${this.base}/syllabus/${id}`, data);
  }

  getSyllabusDetail(id: number | string) {
    return this.get(`${this.base}/syllabus/${id}`);
  }

  deleteSyllabus(id: number | string) {
    return this.remove(`${this.base}/syllabus/${id}`);
  }

  // --- Packages（资源包；数据层对应 articles 模型，接口路径为 packages）---
  getPackagesTree() {
    return this.get(`${this.base}/packages/tree`);
  }

  /** 列表查询参数：page, limit, syllabusId, status, keyword, tagId */
  getPackages(params: any = {}) {
    return this.get(`${this.base}/packages`, params);
  }



  createPackage(data: any) {
    return this.post(`${this.base}/packages`, data);
  }



  getPackageDetail(id: number | string) {
    return this.get(`${this.base}/packages/${id}`);
  }
  getPackageDetailByBook(id: number | string) {
    return this.get(`${this.base}/packages/book/${id}`);
  }



  updatePackage(id: number | string, data: any) {
    return this.patch(`${this.base}/packages/${id}`, data);
  }



  deletePackage(id: number | string) {
    return this.remove(`${this.base}/packages/${id}`);
  }



  // --- Tags（与 articles-manage 共用标签接口）---
  getTags(params: any = {}) {
    return this.get('/tags/oid_packages/list', params);
  }

  checkTagName(name: string) {
    return this.get('/tags/oid_packages/check/name', { name });
  }

  saveTag(data: any) {
    return this.post('/tags/oid_packages/item/save', data);
  }

  deleteTag(id: number | string) {
    return this.post('/tags/oid_packages/item/delete', { id });
  }
}
